var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('shadow-box',{attrs:{"status":_vm.status},on:{"click":_vm.clickShadow}}),_vm._v(" "),_c('transition',{attrs:{"name":"drawer-slide-fade","css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[(_vm.status)?_c('div',{staticClass:"drawer-container",style:(Object.assign({}, {width: _vm.width,
                height: _vm.height,
                zIndex: _vm.zIndex},
                _vm.style.position))},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }